import '../../style/index.less';
import './index.less';
// style dependencies
import '../../tabs/style';
import '../../skeleton/style';
